import { Col, Modal, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
import { useRef, useState } from "react";

const ViewStockCondition = (props) => {

    const singleStockConditionData = props.singleStockConditionData;

    const renderTextWithTooltip = (text) => {
        // Check if the text length exceeds 24 characters
        if (text && text.length > 24) {
            return (
                <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>{text}</Tooltip>}
                >
                    <span>{text.substring(0, 50)}...</span>
                </OverlayTrigger>
            );
        }
        return <span>{text}</span>;
    };

    return (
        <>
            <Modal show={props.showViewDetails} onHide={props.handleCloseViewModal} className='add-customer-modal add-user-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>View Stock Condition</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='customer-form-fields'>
                        <Col>
                            <Row>
                                <Col md={6}>
                                    <div className="view-sla-data">
                                        <label className="pt-1 pb-1">Condition Type </label>
                                        <span>{singleStockConditionData[0]?.StockConditionType}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={6}>
                                    <div className="view-sla-data">
                                        <label className="pt-1 pb-1">Percent Value</label>
                                        <span>{singleStockConditionData[0]?.PercentValue}</span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <div className="view-sla-data">
                                        <label className="pt-1 pb-1"> Description </label>
                                        <span>{renderTextWithTooltip(singleStockConditionData[0]?.StockConditionDescription)}</span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <div className="view-sla-data">
                                        <label className="pt-1 pb-1"> Status </label>
                                        <span>{singleStockConditionData[0]?.Status}</span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                </Modal.Body >
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseViewModal} />
                    <SBSaveUpdateBtn btnName="Ok" />
                </Modal.Footer>
            </Modal >
        </>
    );
}

export default ViewStockCondition;